import React from "react";
import { Box, Typography } from "@mui/material";
import DashboardEmptyIcon from "@assets/images/dashboard-empty.svg";

interface EmptyChartStateProps {
  message?: string;
}

const EmptyChartState: React.FC<EmptyChartStateProps> = ({
  message = "No data available",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        width: "100%",
        height: "100%",
      }}
    >
      <img
        src={DashboardEmptyIcon}
        alt="No data"
        style={{ width: 120, height: 120, opacity: 0.6 }}
      />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ p: 2, textAlign: "center" }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyChartState;
